/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-03 18:13:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/Font/index.tsx
 */

import React from 'react';

import { store } from 'src/store';

import { Checkbox } from '@/src/components/Antd';

import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'src/components/Antd';
import { currentSelectedLanguage } from 'src/constrains/SalesChannelMultiLanguageSelect/slice';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { suffix } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/common';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getFont,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onFontChange,
  onFontReset,
} from '../slice';

const idSet = {
  logographicFont: suffix + 'LogographicFont',
  enableCustomiseFont: suffix + 'EnableCustomiseFont',
  font: suffix + 'Font',
  alphabetFont: suffix + 'AlphabetFont',
};

const Font = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;
  const currentLanguage = useSelector(currentSelectedLanguage());
  const { logographicFont, enableCustomiseFont, alphabetFont, font } =
    data || {};

  const optionsList = [
    { value: 'Open Sans', label: 'Open Sans' },
    { value: 'Garamond', label: 'Garamond' },
    {
      value: 'Merriweather',
      label: 'Merriweather',
    },
    {
      value: 'Roboto Slab',
      label: 'Roboto Slab',
    },
    {
      value: 'Playfair Display',
      label: 'Playfair Display',
    },
    {
      value: 'Lora',
      label: 'Lora',
    },
    {
      value: 'PT Serif',
      label: 'PT Serif',
    },
    {
      value: 'Roboto',
      label: 'Roboto',
    },
    {
      value: 'Noto Sans JP',
      label: 'Noto Sans JP',
    },
    {
      value: 'Lato',
      label: 'Lato',
    },
    {
      value: 'Montserrat',
      label: 'Montserrat',
    },
    {
      value: 'Roboto Mono',
      label: 'Roboto Mono',
    },
    {
      value: 'Inconsolata',
      label: 'Inconsolata',
    },
    {
      value: 'Source Code Pro',
      label: 'Source Code Pro',
    },
    {
      value: 'PT Mono',
      label: 'PT Mono',
    },
    {
      value: 'IBM Plex Mono',
      label: 'IBM Plex Mono',
    },
  ];
  const genericFamilyOption = [
    {
      value: 'Serif',
      label: 'Serif',
    },
    {
      value: 'Sans serif',
      label: 'Sans-serif',
    },
    {
      value: 'System ui',
      label: 'System-ui',
    },
  ];
  const alphabetFontOption = [
    {
      value: 'Serif',
      label: 'Serif',
    },
    {
      value: 'Sans serif',
      label: 'Sans-serif',
    },
    {
      value: 'Monospace',
      label: 'Monospace',
    },
    {
      value: 'System ui',
      label: 'System-ui',
    },
  ];
  const _d = useDispatch();

  // const handleOnFontChange = (fontFamily) => {
  //   _d(onFontChange({ fontFamily }));
  // };

  const handleOnFontChange = (data) => {
    _d(onFontChange(data));
  };
  return (
    <React.Fragment>
      {currentLanguage !== 'en-GB' && (
        <Section bottomBorder>
          <ItemWrapper
            id={idSet.logographicFont}
            title={getI18n('salesChannelContent.index.genericFamily')}>
            <Select
              optionsList={genericFamilyOption}
              onChange={(value) =>
                handleOnFontChange({ logographicFont: value })
              }
              value={logographicFont}
              size={'large'}
            />
          </ItemWrapper>
        </Section>
      )}
      <Section>
        {currentLanguage !== 'en-GB' && (
          <ItemWrapper id={idSet.enableCustomiseFont}>
            <Checkbox
              checked={enableCustomiseFont}
              onChange={() =>
                handleOnFontChange({
                  enableCustomiseFont: !enableCustomiseFont,
                })
              }>
              {getI18n(
                'salesChannelContent.index.customisealphabetlettersfont',
              )}
            </Checkbox>
          </ItemWrapper>
        )}

        {(enableCustomiseFont || currentLanguage == 'en-GB') && (
          <ItemWrapper id={idSet.font} title={getI18n('general.hOCTitle.font')}>
            <Select
              optionsList={optionsList}
              onChange={(value) => handleOnFontChange({ font: value })}
              value={font}
              size={'large'}
            />
          </ItemWrapper>
        )}

        {(enableCustomiseFont || currentLanguage == 'en-GB') && (
          <ItemWrapper
            id={idSet.alphabetFont}
            title={getI18n('salesChannelContent.index.genericFamily')}>
            <Select
              optionsList={alphabetFontOption}
              onChange={(value) => handleOnFontChange({ alphabetFont: value })}
              value={alphabetFont}
              size={'large'}
            />
          </ItemWrapper>
        )}
      </Section>
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(Font, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.font,
  getContent: getFont,
  title: getI18nFromGeneral('general.hOCTitle.font'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //validation: validateSeoSetting,
  getSubmitStamp,
  headerProps: {
    dotsFunction: [
      {
        onClick: () => {
          store.dispatch(onFontReset());
        },
        key: 'Reset',
        body: getI18nFromGeneral('general.hOCTitle.reset'),
        isDangerous: true,
      },
    ],
    hasDots: true,
    hideDotsWhenNotPrimary: true,
  },
});
